import { getAxiosInstance } from "../../../api";

export const updateRemittanceSettings = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.put("admin/remittance/settings/update", body);
    return response;
  } catch (error) {
    return error.response.data;
  }
};
